<div class="current-slip-core-desktop mobile">
  <div class="container">
    <ng-container *ngIf="isMobileView === false">
      <ng-container>
        <div *ngIf="this._UiHelper.settingsModalOpen" [class]="'settingsModal-desktop'">
          <bet-settings class="settings-animate"></bet-settings>
        </div>
      </ng-container>
      <div class="bets-summary">
        <div class="bet-item" (click)="slipHeaderChangeTab(1)" [ngClass]="{ active: this._UiHelper.currentSlipHeaderTabSelected === 1 }">
          <div class="bet-value">{{ this._DataHelper.currentSlipData.length }}</div>
          <div class="bet-label">{{ 'Bets_slip' | translate }}</div>
        </div>
        <div class="bet-item" (click)="slipHeaderChangeTab(2)" [ngClass]="{ active: this._UiHelper.currentSlipHeaderTabSelected === 2 }">
          <div class="bet-value">{{ this._DataHelper.cashoutSlipsList.length }}</div>
          <div class="bet-label">{{ 'MyBets' | translate }}</div>
        </div>
      </div>
    </ng-container>
    <div class="content">
      <div class="bet-slip-container">
        <!--- Bet Slip currentSlipHeaderTabSelected = 1 --->
        <ng-container *ngIf="this._UiHelper.currentSlipHeaderTabSelected == 1">
          <div class="mobile-page-header" *ngIf="isMobileView === true">
            <div class="left-side">
              <span>{{ 'bet_slip' | translate }}</span>
              <span>({{ this._DataHelper.currentSlipData.length }})</span>
            </div>
            <ng-container *ngIf="('isBetSettings' | getEnv) && !_DataHelper.freebetBonusCheckBox && !_DataHelper.boostBonusCheckBox">
              <div class="mr-10" (click)="openSettingsModal()">
                <image-loader-utils url="settings" extraClasses="setting-icon"></image-loader-utils>
              </div>
            </ng-container>
            <div class="right-side" (click)="CurrentSlipBack()">
              <image-loader-utils url="up-arrow" extraClasses="arrow-icon down icon-lg"></image-loader-utils>
            </div>
          </div>

          <ng-container *ngIf="this._UiHelper.settingsModalOpen && isMobileView">
            <bet-settings class="settings-animate"></bet-settings>
          </ng-container>
          <ng-container *ngIf="!this._UserHelper.isSignedIn && !this.isMobileView && IsRegisterActive">
            <div class="be-register-card">
              <div class="be-register-header">{{ 'new_customer' | translate }}</div>
              <div class="body">{{ 'need_to_register_notification' | translate }}</div>
              <div class="bottom-action-area">
                <div class="register-button" [routerLink]="['/register']">{{ 'register_now' | translate }}</div>
              </div>
            </div>
          </ng-container>
          <div class="empty text sl-round round-bl-5 round-br-5" *ngIf="this._DataHelper.currentSlipData.length == 0 && !isMobileView">
            <div class="bet-slip-empty-container">
              <image-loader-utils url="empty-betslip" extraClasses="bet-slip-empty-container-svg"></image-loader-utils>
              <div class="bet-slip-empty-text">
                {{ 'current_slip_empty_text_1' | translate }}
              </div>
              <div class="bet-slip-empty-text">
                {{ 'current_slip_empty_text_2' | translate }}
              </div>
            </div>
          </div>

          <ng-container *ngIf="this._DataHelper.currentSlipData.length > 0">
            <div class="settings-general-container">
              <div class="combo-container">
                <div class="dropdown-container">
                  <div class="dropdown-header" (click)="toggleSystemDropdown()">
                    {{ selectedText || 'System no system selected' }}
                    <span class="arrow" [ngClass]="{ open: isSystemDropdownOpen }"></span>
                  </div>
                  <div class="dropdown-menu" *ngIf="isSystemDropdownOpen">
                    <ng-container *ngFor="let systemSlip of this._DataHelper.currentSlipSystemInfo; let i = index; trackBy: trackByFnSystemCombinations">
                      <div class="dropdown-item" [ngClass]="{ hide: systemSlip.combination > 330 }">
                        <input
                          type="checkbox"
                          id="system_checkbox_{{ i + 1 }}"
                          name="system_checkbox_{{ i + 1 }}"
                          (change)="changeAmount($event, systemSlip.index, systemSlip.combination)"
                          [checked]="this._DataHelper.currentSlipSystemSelection.includes(systemSlip.index + 1 + '_' + systemSlip.combination)" />
                        <label for="system_checkbox_{{ i + 1 }}">
                          {{ 'System' | translate }} {{ i + 1 }}/{{ this._DataHelper.currentSlipSystemInfo.length }} (<strong
                            >{{ systemSlip.combination }} {{ 'Bets' | translate }}</strong
                          >)
                        </label>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </div>
              <div class="settings-container" (click)="openSettingsModal()">
                <div class="theme-button navbar-right-side-item setting-button">
                  <image-loader-utils url="bet-settings" extraClasses="theme-svg"></image-loader-utils>
                </div>
              </div>
              <div class="delete-container">
                <div *ngIf="removeAllStep === 1" (click)="removeAll()" class="remove-all-button">
                  <div>
                    <image-loader-utils url="trash" extraClasses="left-side-trash"></image-loader-utils>
                  </div>
                </div>
                <div *ngIf="removeAllStep === 2" (click)="removeAll()" class="remove-all-button step-2">
                  <div>
                    <image-loader-utils url="trash" extraClasses="left-side-trash"></image-loader-utils>
                  </div>
                  <div class="btn-remove-all">{{ 'Remove_all_comfirm' | translate }}</div>
                </div>
              </div>
            </div>
            <div class="tickets">
              <div class="ticket-item sl-round round-5 card" *ngFor="let slipEvent of this._DataHelper.currentSlipData.reverse() | groupByEventName; first as isFirst">
                <div class="odd-box">
                  <div
                    class="odd-row"
                    (click)="oddDetail(slipEvent)"
                    [ngClass]="slipCurrent.Visibility === 'hidden' ? 'odd-locked' : ''"
                    *ngFor="let slipCurrent of slipEvent?.eEvents">
                    <image-loader-utils url="fa-lock" extraClasses="odd-locked-icon lock-icon colorG"></image-loader-utils>
                    <div class="odd">
                      <div class="left">
                        <span style="font-weight: 600">
                          {{ slipCurrent.OddsType }}
                          <b> {{ slipCurrent.SpecialBetValue }}&nbsp;:&nbsp;{{ slipCurrent.OutCome }} </b>
                        </span>
                      </div>
                      <div class="mid"></div>
                      <div
                        class="right"
                        [ngClass]="{
                          'odd-up': !this._UiHelper.checkboxAcceptOdds && slipCurrent.FirstOddValue1 < slipCurrent.OddValue1,
                          'odd-down': !this._UiHelper.checkboxAcceptOdds && slipCurrent.FirstOddValue1 > slipCurrent.OddValue1
                        }">
                        {{ slipCurrent.Visibility === 'hidden' ? '-' : (slipCurrent.OddValue1 | oddFormat) }}

                        <div class="close" (click)="removeOdd(slipCurrent.OddId1)">
                          <image-loader-utils url="bet-close" extraClasses="times-circle-icon"></image-loader-utils>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="match-row">
                  <div class="banko" *ngIf="this._UiHelper.currentSlipTabSelected == 2">
                    <div class="btn-banko" [ngClass]="slipEvent.Banko == true ? 'active' : ''" (click)="changeSelectedSlipCurrent(slipEvent)">B</div>
                  </div>
                  <div class="match-info" (click)="goEventDetail2(slipEvent.MatchId, slipEvent.MatchId, slipEvent, getLiveEvent(slipEvent.MatchId))">
                    <div class="team-name">{{ slipEvent.HomeTeam }}</div>
                    <div class="team-name">{{ slipEvent.AwayTeam }}</div>
                  </div>
                  <div class="match-score" *ngIf="!getLiveEvent(slipEvent.MatchId)">
                    <div class="score-box"></div>
                    <div class="score-box now">
                      <div class="text">
                        {{
                          (slipEvent.EventDateLong | dateFormat : 'dd-MM') == (this.today | dateFormat : 'dd-MM')
                            ? ('today' | translate)
                            : (slipEvent.EventDateLong | dateFormat : 'dd.MM')
                        }}
                      </div>
                      <div class="text">
                        {{ slipEvent.EventDateLong | dateFormat : 'H:mm' }}
                      </div>
                    </div>
                  </div>
                  <div class="match-score" *ngIf="getLiveEvent(slipEvent.MatchId) as eventObj">
                    <div class="score-box">
                      {{ eventObj.TimeStatu != 3 ? (eventObj.MatchTime != null ? eventObj.MatchTime + "'" : '') : eventObj.TimeStatuColor.trim() }}
                    </div>
                    <div class="score-box now">
                      <span>
                        {{ eventObj.Score != null && eventObj.Score !== '' ? eventObj.Score.split(':')[0] : '' }}
                      </span>
                      <span>
                        {{ eventObj.Score != null && eventObj.Score !== '' ? eventObj.Score.split(':')[1].trim() : '' }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div *ngIf="isMobileView === false" #brWidget id="widgetContainer" style="margin-bottom: 15px"></div>
            <div *ngIf="isMobileView === true" #brWidgetM id="widgetContainerM"></div>

            <!-- Mobile accept change and max odd area -->
            <div class="accept-change-row" *ngIf="isMobileView === true && this._DataHelper.selectedWallet.IsFreeBetBonus && this._DataHelper.customerFreeBetBonusInfo">
              <div class="freebet-container">
                <!-- Kullanıcının bahis şartları sağlanması ve System ve Multiway bahis yapması kontrolü burada sağlanmıştır -->

                <ng-container *ngIf="this.isFreeBetAble(); else nonablefreebet">
                  <div class="freebet-row">
                    <input type="checkbox" name="freebet" id="freebet" [(ngModel)]="_DataHelper.freebetBonusCheckBox" (change)="changeTotalStakeBonus($event.target.checked)" />
                    <label class="freebet-label" for="freebet"
                      >{{ this._DataHelper.customerFreeBetBonusInfo?.BonusAmount }} {{ _UserHelper.customerUser?.Symbol }} {{ 'freebet' | translate }}</label
                    >
                  </div>
                  <div class="freebet-row bold" (click)="openInfoFreebetModal()">
                    <u>{{ 'freebet_1' | translate }}</u>
                  </div>
                </ng-container>

                <ng-template #nonablefreebet>
                  <div class="freebet-row">
                    <label class="freebet-label disabled" for="freebet"
                      >{{ this._DataHelper.customerFreeBetBonusInfo?.BonusAmount }} {{ _UserHelper.customerUser?.Symbol }} {{ 'freebet' | translate }}</label
                    >
                  </div>
                  <div class="freebet-row bold">
                    <span
                      >{{ 'freebet_2' | translate }} <u (click)="openInfoFreebetModal()">{{ 'freebet_1' | translate }}</u></span
                    >
                  </div>
                </ng-template>
              </div>
            </div>
            <div class="accept-change-row" *ngIf="isMobileView === true && this._UiHelper.bottomActiveItem === 15">
              <div class="left-side">
                <ng-container *ngIf="!('isBetSettings' | getEnv)">
                  <input type="checkbox" id="accept-odds-mobile" (change)="this._UiHelper.setAcceptOdds($event)" [(ngModel)]="this._UiHelper.checkboxAcceptOdds" />
                  <label for="accept-odds-mobile">
                    {{ 'Accept_odds_change' | translate }}
                  </label>
                </ng-container>
              </div>

              <ng-container
                *ngIf="
                  !_DataHelper.boostBonusCheckBox ||
                    !(
                      !(this._UiHelper.currentSlipTabSelected === 0 && this._DataHelper.currentSlipData.length > 1) &&
                      this._DataHelper.currentSlipInfo.currentslip_totalStake <= this._DataHelper.customerBoostBonusInfo?.MaxAmount &&
                      this._DataHelper.customerBoostBonusInfo?.MinAmount <= this._DataHelper.currentSlipInfo.currentslip_totalStake &&
                      (this._DataHelper.customerBoostBonusInfo?.MinOddValue | balanceFormat) <= (this._DataHelper.currentSlipInfo.OldTotalRate | balanceFormat) &&
                      this._DataHelper.currentSlipInfo.OldTotalRate <= this._DataHelper.customerBoostBonusInfo?.MaxOddValue &&
                      this._DataHelper.customerBoostBonusInfo?.MinEventCount <= this._DataHelper.currentSlipInfo.numberOfBets &&
                      this._UiHelper.currentSlipTabSelected != 2 &&
                      !this._DataHelper.currentSlipInfo.isMultiWaySystem
                    );
                  else boostBonusCheckedMobile
                ">
                <div class="right-side">
                  <span class="desc">{{ 'Max_Odds' | translate }} :</span>
                  <span class="value">{{ this._DataHelper.currentSlipInfo.currentTotalRate | oddFormat }}</span>
                </div>
              </ng-container>
              <ng-template #boostBonusCheckedMobile>
                <div class="right-side boosted">
                  <span class="desc">{{ 'boosted_winnings' | translate }} :</span>
                  <span class="value">
                    <span class="line-text"> {{ this._DataHelper.currentSlipInfo.OldTotalRate | oddFormat }}</span>

                    {{ this._DataHelper.currentSlipInfo.currentTotalRate | oddFormat }}</span
                  >
                  <image-loader-utils url="rocket" extraClasses="lugassvg"></image-loader-utils>
                </div>
              </ng-template>
            </div>
            <div class="quoten-boost-bonus-container" *ngIf="this._DataHelper.selectedWallet.IsBoostBonus && this._DataHelper.customerBoostBonusInfo">
              <ng-container
                *ngIf="
                  !(this._UiHelper.currentSlipTabSelected === 0 && this._DataHelper.currentSlipData.length > 1) &&
                    this._DataHelper.currentSlipInfo.currentslip_totalStake <= this._DataHelper.customerBoostBonusInfo?.MaxAmount &&
                    this._DataHelper.customerBoostBonusInfo?.MinAmount <= this._DataHelper.currentSlipInfo.currentslip_totalStake &&
                    (this._DataHelper.customerBoostBonusInfo?.MinOddValue | balanceFormat) <= (this._DataHelper.currentSlipInfo.OldTotalRate | balanceFormat) &&
                    this._DataHelper.currentSlipInfo.OldTotalRate <= this._DataHelper.customerBoostBonusInfo?.MaxOddValue &&
                    this._DataHelper.customerBoostBonusInfo?.MinEventCount <= this._DataHelper.currentSlipInfo.numberOfBets &&
                    this._UiHelper.currentSlipTabSelected != 2 &&
                    !this._DataHelper.currentSlipInfo.isMultiWaySystem;
                  else nonableboostbet
                ">
                <div class="quoten-boost-row">
                  <div class="icon-container" (click)="openInfoBoostModal(true)">
                    <image-loader-utils url="rocket" extraClasses="lugassvg"></image-loader-utils>
                  </div>
                  <div class="mid-container">
                    <div class="mid-container-row">{{ this._DataHelper.customerBoostBonusInfo?.BonusRate }} {{ 'Odds_Boost' | translate }}</div>
                    <div class="mid-container-row">{{ 'until' | translate }} {{ this._DataHelper.customerBoostBonusInfo?.EndDate | dateFormat : 'dd.MM.yy HH:mm' }}</div>
                  </div>
                  <div class="right-container">
                    <image-loader-utils (click)="openInfoBoostModal(true)" url="info-circle" extraClasses="infosvg"></image-loader-utils>
                    <input
                      type="checkbox"
                      name="boostbonus"
                      id="boostbonus"
                      class="quoten_checkbox_with_label"
                      required="{{ 'Required' | translate }}"
                      [(ngModel)]="_DataHelper.boostBonusCheckBox"
                      (change)="changeTotalRateBonus($event.target.checked)" />
                  </div>
                </div>
              </ng-container>
              <ng-template #nonableboostbet>
                <div class="quoten-boost-row disabled" (click)="openInfoBoostModal(false)">
                  <div class="icon-container">
                    <image-loader-utils url="rocket" extraClasses="lugassvg"></image-loader-utils>
                  </div>
                  <div class="mid-container">
                    <div class="mid-container-row">{{ this._DataHelper.customerBoostBonusInfo?.BonusRate }} {{ 'Odds_Boost' | translate }}</div>
                    <div class="mid-container-row">{{ 'until' | translate }} {{ this._DataHelper.customerBoostBonusInfo?.EndDate | dateFormat : 'dd.MM.yy HH:mm' }}</div>
                  </div>
                  <div class="right-container">
                    <image-loader-utils url="info-circle" extraClasses="infosvg"></image-loader-utils>
                    <input type="checkbox" name="boostbonus" id="boostbonus" class="quoten_checkbox_with_label" required="{{ 'Required' | translate }}" disabled />
                  </div>
                </div>
              </ng-template>
            </div>
            <div *ngIf="isMobileView === false" class="slip-amount-container sl-round round-tl-5 round-tr-5 card">
              <div class="slip-amount-row" *ngIf="this._DataHelper.selectedWallet.IsFreeBetBonus && this._DataHelper.customerFreeBetBonusInfo">
                <div class="freebet-container">
                  <!-- Kullanıcının bahis şartları sağlanması ve System ve Multiway bahis yapması kontrolü burada sağlanmıştır -->
                  <ng-container *ngIf="this.isFreeBetAble(); else nonablefreebet">
                    <div class="freebet-row">
                      <input type="checkbox" name="freebet" id="freebet" [(ngModel)]="_DataHelper.freebetBonusCheckBox" (change)="changeTotalStakeBonus($event.target.checked)" />
                      <label class="freebet-label" for="freebet"
                        >{{ this._DataHelper.customerFreeBetBonusInfo?.BonusAmount }} {{ _UserHelper.customerUser?.Symbol }} {{ 'freebet' | translate }}</label
                      >
                    </div>
                    <div class="freebet-row bold" (click)="openInfoFreebetModal()">
                      <u>{{ 'freebet_1' | translate }}</u>
                    </div>
                  </ng-container>

                  <ng-template #nonablefreebet>
                    <div class="freebet-row">
                      <label class="freebet-label disabled" for="freebet"
                        >{{ this._DataHelper.customerFreeBetBonusInfo?.BonusAmount }} {{ _UserHelper.customerUser?.Symbol }} {{ 'freebet' | translate }}</label
                      >
                    </div>
                    <div class="freebet-row bold">
                      <span
                        >{{ 'freebet_2' | translate }} <u (click)="openInfoFreebetModal()">{{ 'freebet_1' | translate }}</u></span
                      >
                    </div>
                  </ng-template>
                </div>
              </div>
              <ng-container
                *ngIf="
                  !(
                    !(this._UiHelper.currentSlipTabSelected === 0 && this._DataHelper.currentSlipData.length > 1) &&
                    this._DataHelper.currentSlipInfo.currentslip_totalStake <= this._DataHelper.customerBoostBonusInfo?.MaxAmount &&
                    this._DataHelper.customerBoostBonusInfo?.MinAmount <= this._DataHelper.currentSlipInfo.currentslip_totalStake &&
                    (this._DataHelper.customerBoostBonusInfo?.MinOddValue | balanceFormat) <= (this._DataHelper.currentSlipInfo.OldTotalRate | balanceFormat) &&
                    this._DataHelper.currentSlipInfo.OldTotalRate <= this._DataHelper.customerBoostBonusInfo?.MaxOddValue &&
                    this._DataHelper.customerBoostBonusInfo?.MinEventCount <= this._DataHelper.currentSlipInfo.numberOfBets &&
                    this._UiHelper.currentSlipTabSelected != 2 &&
                    !this._DataHelper.currentSlipInfo.isMultiWaySystem
                  ) && this._DataHelper.customerBoostBonusInfo
                ">
                <div class="error-amount-row">
                  <image-loader-utils url="info-circle-danger" extraClasses="check-circle-icon lost"></image-loader-utils>

                  {{ 'boosted_error_message' | translate }}
                </div>
              </ng-container>
              <div class="slip-amount-row two-col">
                <ng-container
                  *ngIf="
                    !_DataHelper.freebetBonusCheckBox ||
                      !(
                        (this._DataHelper.customerFreeBetBonusInfo?.MinOddValue | balanceFormat) <= (this._DataHelper.currentSlipInfo.totalRate | balanceFormat) &&
                        this._DataHelper.currentSlipInfo.totalRate <= this._DataHelper.customerFreeBetBonusInfo?.MaxOddValue &&
                        this._DataHelper.customerFreeBetBonusInfo?.MinEventCount <= this._DataHelper.currentSlipInfo.numberOfBets
                      );
                    else disabledAmountInput
                  ">
                  <div class="slip-amount-input">
                    <p class="input-row">
                      {{ _UserHelper.isSignedIn ? _UserHelper?.customerUser?.Symbol : environment?.currencySymbol }}
                      <input
                        placeholder="0"
                        (blur)="onBlurTotalStake($event)"
                        (keyup)="changeTotalStake($event)"
                        [value]="this._DataHelper.currentSlipInfo.currentslip_totalStake"
                        class="slip-amount-borderless-input" />
                    </p>
                    <span class="slip-amount-subtext">{{ 'ToPay' | translate }}</span>
                  </div>
                </ng-container>
                <ng-template #disabledAmountInput>
                  <div class="slip-amount-input disabled">
                    <p class="input-row">
                      {{ _UserHelper.isSignedIn ? _UserHelper?.customerUser?.Symbol : environment?.currencySymbol }}
                      <input placeholder="0" [readonly]="true" [value]="this._DataHelper.currentSlipInfo.currentslip_totalStake" class="slip-amount-borderless-input" />
                    </p>
                    <span class="slip-amount-subtext">{{ 'ToPay' | translate }}</span>
                  </div>
                </ng-template>
                <ng-container *ngIf="!_DataHelper.boostBonusCheckBox; else boostBonusCheckedGain">
                  <div class="slip-amount-gain">
                    <p class="subtext">{{ 'Possible_winnings' | translate }}</p>
                    <p class="pg-amount">{{ this._DataHelper.currentSlipInfo.maxGain | balanceFormat }}</p>
                  </div>
                </ng-container>
                <ng-template #boostBonusCheckedGain>
                  <div class="slip-amount-gain">
                    <p class="subtext">{{ 'boosted_winnings' | translate }}</p>
                    <p class="pg-amount">
                      <image-loader-utils url="rocket" extraClasses="lugassvg"></image-loader-utils>

                      {{ this._DataHelper.currentSlipInfo.maxGain | balanceFormat }}
                    </p>
                  </div>
                </ng-template>
              </div>
              <div class="slip-amount-row" *ngIf="this._DataHelper.currentSlipInfo.tax !== ''">
                <div class="left">{{ 'Fee' | translate }}</div>
                <div class="right">{{ this._DataHelper.currentSlipInfo.tax | balanceFormat }}</div>
              </div>
              <div *ngIf="isQuickAmount && !_DataHelper.freebetBonusCheckBox" class="submit-quick-amount-row">
                <ng-container *ngFor="let item of this._DataHelper.default_amount_arr">
                  <div
                    class="submit-quick-amount"
                    [class.active]="this._DataHelper.currentSlipInfo.currentslip_totalStake == item.amount_value"
                    (click)="this._DataHelper.currentSlipInfo.currentslip_totalStake !== item.amount_value && setActiveQuickAmount(item.amount_value)">
                    <ng-container *ngIf="isBalanceFormatShow">
                      {{ item.amount_value | balanceFormat }}
                    </ng-container>
                    <ng-container *ngIf="!isBalanceFormatShow">
                      <span>{{ item.amount_value }}</span>
                    </ng-container>
                  </div>
                </ng-container>
              </div>
              <div class="slip-amount-row">
                <div class="left">{{ 'Amount_Per_Bet' | translate }} ({{ this._DataHelper.currentSlipInfo.numberOfBets }} {{ 'Bets' | translate }} )</div>
                <div class="right">{{ this._DataHelper.currentSlipInfo.amountPerBet | balanceFormat }}</div>
              </div>

              <div class="slip-amount-row">
                <div class="left">{{ 'Number_Of_Bets' | translate }}</div>
                <div class="right">{{ this._DataHelper.currentSlipInfo.numberOfBets }}</div>
              </div>
              <ng-container *ngIf="!_DataHelper.boostBonusCheckBox; else boostBonusChecked">
                <div class="slip-amount-row">
                  <div class="left">{{ 'Total_Rate' | translate }}</div>
                  <div class="right">{{ this._DataHelper.currentSlipInfo.totalRate | oddFormat }}</div>
                </div>
              </ng-container>
              <ng-template #boostBonusChecked>
                <div class="slip-amount-row">
                  <div class="left">{{ 'boosted_odds' | translate }}</div>
                  <div class="right">
                    <span class="line-text"> {{ this._DataHelper.currentSlipInfo.OldTotalRate | oddFormat }}</span>
                    {{ this._DataHelper.currentSlipInfo.totalRate | oddFormat }}
                  </div>
                </div>
              </ng-template>

              <div class="slip-amount-row">
                <div class="left">{{ 'Max_Possible_winnings' | translate }}</div>
                <div class="right">{{ this._DataHelper.currentSlipInfo.maxGain | balanceFormat }}</div>
              </div>
              <ng-container>
                <div class="slip-amount-row">
                  <div class="left">{{ 'Min_Possible_winnings' | translate }}</div>
                  <div class="right">{{ this._DataHelper.currentSlipInfo.minGain | balanceFormat }}</div>
                </div>
              </ng-container>
            </div>
            <div *ngIf="isMobileView === true && this._UiHelper.bottomActiveItem === 15" class="slip-amount-container">
              <ng-container *ngIf="keyboardIsOpen">
                <div class="keyboard-total-stake-row">
                  <div class="left-side">{{ 'Total_Stake' | translate }}</div>
                  <div class="right-side">
                    <div class="keyboard-total-stake-input">
                      <div class="keyboard-total-stake">
                        {{ this._DataHelper.currentSlipInfo.currentslip_totalStake }}
                      </div>
                      <div class="keyboard-total-stake-currency">
                        {{ _UserHelper.customerUser?.Symbol }}
                      </div>
                    </div>
                  </div>
                </div>

                <div class="slip-amount-keyboard">
                  <div class="left-side">
                    <div class="keyboard-button" (click)="changeStakeInKeyboardp1001(1)">1</div>
                    <div class="keyboard-button" (click)="changeStakeInKeyboardp1001(2)">2</div>
                    <div class="keyboard-button" (click)="changeStakeInKeyboardp1001(3)">3</div>
                    <div class="keyboard-button" (click)="changeStakeInKeyboardp1001(4)">4</div>
                    <div class="keyboard-button" (click)="changeStakeInKeyboardp1001(5)">5</div>
                    <div class="keyboard-button" (click)="changeStakeInKeyboardp1001(6)">6</div>
                    <div class="keyboard-button" (click)="changeStakeInKeyboardp1001(7)">7</div>
                    <div class="keyboard-button" (click)="changeStakeInKeyboardp1001(8)">8</div>
                    <div class="keyboard-button" (click)="changeStakeInKeyboardp1001(9)">9</div>
                    <div class="keyboard-button" (click)="changeStakeInKeyboardp1001('.')">.</div>
                    <div class="keyboard-button" (click)="changeStakeInKeyboardp1001(0)">0</div>
                    <div class="keyboard-button" (click)="changeStakeInKeyboardp1001(0, 'backspace')">
                      <image-loader-utils url="back"></image-loader-utils>
                    </div>
                  </div>
                  <div class="right-side">
                    <div class="keyboard-button right" (click)="changeStakeInKeyboardp1001(0, '+10')">+ 10</div>
                    <div class="keyboard-button right" (click)="changeStakeInKeyboardp1001(0, '+50')">+ 50</div>
                    <div class="keyboard-button right" (click)="changeStakeInKeyboardp1001(1, 'C')">C</div>
                    <div class="keyboard-button right" (click)="changeKeyboardState(false)">OK</div>
                  </div>
                </div>
              </ng-container>
              <ng-container *ngIf="!keyboardIsOpen">
                <ng-container
                  *ngIf="
                    !(
                      !(this._UiHelper.currentSlipTabSelected === 0 && this._DataHelper.currentSlipData.length > 1) &&
                      this._DataHelper.currentSlipInfo.currentslip_totalStake <= this._DataHelper.customerBoostBonusInfo?.MaxAmount &&
                      this._DataHelper.customerBoostBonusInfo?.MinAmount <= this._DataHelper.currentSlipInfo.currentslip_totalStake &&
                      (this._DataHelper.customerBoostBonusInfo?.MinOddValue | balanceFormat) <= (this._DataHelper.currentSlipInfo.OldTotalRate | balanceFormat) &&
                      this._DataHelper.currentSlipInfo.OldTotalRate <= this._DataHelper.customerBoostBonusInfo?.MaxOddValue &&
                      this._DataHelper.customerBoostBonusInfo?.MinEventCount <= this._DataHelper.currentSlipInfo.numberOfBets &&
                      this._UiHelper.currentSlipTabSelected != 2 &&
                      !this._DataHelper.currentSlipInfo.isMultiWaySystem
                    ) && this._DataHelper.customerBoostBonusInfo
                  ">
                  <div class="error-amount-row">
                    <image-loader-utils url="info-circle-danger" extraClasses="check-circle-icon lost"></image-loader-utils>

                    {{ 'boosted_error_message' | translate }}
                  </div>
                </ng-container>
                <div class="total-stake-result-row">
                  <ng-container
                    *ngIf="
                      !_DataHelper.freebetBonusCheckBox ||
                        !(
                          (this._DataHelper.customerFreeBetBonusInfo?.MinOddValue | balanceFormat) <= (this._DataHelper.currentSlipInfo.totalRate | balanceFormat) &&
                          this._DataHelper.currentSlipInfo.totalRate <= this._DataHelper.customerFreeBetBonusInfo?.MaxOddValue &&
                          this._DataHelper.customerFreeBetBonusInfo?.MinEventCount <= this._DataHelper.currentSlipInfo.numberOfBets
                        );
                      else disabledAmountMobile
                    ">
                    <div class="left-side">
                      <div class="total-stake-result" (click)="changeKeyboardState(true)">
                        <div class="value">
                          {{ this._DataHelper.currentSlipInfo.currentslip_totalStake | balanceFormat }}
                        </div>
                        <div class="desc">{{ 'Total_Stake' | translate }}</div>
                      </div>
                    </div>
                  </ng-container>

                  <ng-template #disabledAmountMobile>
                    <div class="left-side">
                      <div class="total-stake-result disabled">
                        <div class="value">
                          {{ this._DataHelper.currentSlipInfo.currentslip_totalStake | balanceFormat }}
                        </div>
                        <div class="desc">{{ 'Total_Stake' | translate }}</div>
                      </div>
                    </div>
                  </ng-template>

                  <!-- 0 - 1 -  Is Single or Multiple -->

                  <div class="right-side" *ngIf="this._UiHelper.currentSlipTabSelected != 2">
                    <div class="possible-winning">
                      <div class="value">{{ this._DataHelper.currentSlipInfo.maxGain | balanceFormat }}</div>
                      <div class="desc">{{ 'Possible_winnings' | translate }}</div>
                    </div>
                  </div>

                  <!-- 2 -  Is System -->
                  <div class="right-side-winning" *ngIf="this._UiHelper.currentSlipTabSelected == 2">
                    <div class="winning">
                      <div class="desc">{{ 'Max_Possible_winnings' | translate }}</div>
                      <div class="value">{{ this._DataHelper.currentSlipInfo.maxGain | balanceFormat }}</div>
                    </div>
                    <ng-container>
                      <div class="winning">
                        <div class="desc">{{ 'Min_Possible_winnings' | translate }}</div>
                        <div class="value">{{ this._DataHelper.currentSlipInfo.minGain | balanceFormat }}</div>
                      </div>
                    </ng-container>
                  </div>
                </div>

                <div *ngIf="isQuickAmount && !_DataHelper.freebetBonusCheckBox" class="submit-quick-amount-row">
                  <ng-container *ngFor="let item of this._DataHelper.default_amount_arr">
                    <div
                      class="submit-quick-amount"
                      [class.active]="this._DataHelper.currentSlipInfo.currentslip_totalStake == item.amount_value"
                      (click)="this._DataHelper.currentSlipInfo.currentslip_totalStake !== item.amount_value && setActiveQuickAmount(item.amount_value)">
                      <ng-container *ngIf="isBalanceFormatShow">
                        {{ item.amount_value | balanceFormat }}
                      </ng-container>
                      <ng-container *ngIf="!isBalanceFormatShow">
                        <span>{{ item.amount_value }}</span>
                      </ng-container>
                    </div>
                  </ng-container>
                </div>
                <div class="slip-amount-row" *ngIf="this._DataHelper.currentSlipInfo.tax !== ''">
                  <div class="left">{{ 'Fee' | translate }}</div>
                  <div class="right">
                    {{ getNumber(this._DataHelper.currentSlipInfo.tax) | balanceFormat }}
                  </div>
                </div>
                <div class="slip-amount-row">
                  <div class="left">{{ 'Amount_Per_Bet' | translate }} ({{ this._DataHelper.currentSlipInfo.numberOfBets }} {{ 'Bets' | translate }} )</div>
                  <div class="right">{{ this._DataHelper.currentSlipInfo.amountPerBet | balanceFormat }}</div>
                </div>
              </ng-container>
            </div>
            <ng-container *ngIf="isMobileView === false; else mobileTemplate">
              <div class="slip-amount-bottom sl-round round-bl-5 round-br-5 card">
                <ng-container *ngIf="!('isBetSettings' | getEnv)">
                  <div *ngIf="isMobileView === false" class="accept-odds">
                    <input type="checkbox" id="accept-odds" (change)="this._UiHelper.setAcceptOdds($event)" [(ngModel)]="this._UiHelper.checkboxAcceptOdds" />
                    <label for="accept-odds">{{ 'accept_change_of_odds' | translate }}</label>
                  </div>
                </ng-container>

                <ng-container *ngIf="this._UiHelper.placeBetIsActive">
                  <div class="curent-slip-core-button-row">
                    <button class="submit-ok-button" (click)="placeBet()" mat-stroked-button>
                      {{ 'Confirm' | translate }}
                    </button>
                    <button class="cancel-button" (click)="placeBetActive(false)" mat-stroked-button>
                      {{ 'Modify' | translate }}
                    </button>
                  </div>
                </ng-container>
                <ng-container *ngIf="!this._UiHelper.placeBetIsActive">
                  <div class="submit-bet-row-container">
                    <div class="submit-bet-row-item" [ngClass]="('bookBetQrCode' | getEnv) ? 'isBookBetQrCode' : ''">
                      <ng-container *ngIf="'isJacktimeActive' | getEnv; else isJacktimeNoActive">
                        <div
                          class="btn colored big-size-place"
                          *ngIf="
                            (this._UiHelper.checkboxAcceptOdds || !this._DataHelper.currentSlipInfo.oddIsChange) &&
                            (!this._DataHelper.currentSlipInfo.isCheckIsSystem || this._UiHelper.currentSlipTabSelected != 2 || !this._DataHelper.currentSlipInfo.isMultiWaySystem)
                          "
                          (click)="placeBetActive(true)">
                          {{ 'Submit_Bet' | translate }}
                        </div>
                        <div
                          class="btn colored big-size-place"
                          *ngIf="
                            (this._UiHelper.checkboxAcceptOdds || !this._DataHelper.currentSlipInfo.oddIsChange) &&
                            this._DataHelper.currentSlipInfo.isMultiWaySystem &&
                            this._DataHelper.currentSlipInfo.isCheckIsSystem &&
                            this._UiHelper.currentSlipTabSelected == 2
                          "
                          (click)="placeBetActive(true)">
                          {{ 'Submit_Bet' | translate }}
                        </div>
                      </ng-container>
                      <ng-template #isJacktimeNoActive>
                        <div
                          class="btn colored big-size-place"
                          *ngIf="
                            (this._UiHelper.checkboxAcceptOdds || !this._DataHelper.currentSlipInfo.oddIsChange) &&
                            (!this._DataHelper.currentSlipInfo.isCheckIsSystem || this._UiHelper.currentSlipTabSelected != 2 || !this._DataHelper.currentSlipInfo.isMultiWaySystem)
                          "
                          (click)="placeBetActive(true)">
                          {{ 'Submit_Bet' | translate }}
                        </div>
                        <div
                          class="btn colored no-cashout-button two-line-info"
                          *ngIf="
                            (this._UiHelper.checkboxAcceptOdds || !this._DataHelper.currentSlipInfo.oddIsChange) &&
                            this._DataHelper.currentSlipInfo.isMultiWaySystem &&
                            this._DataHelper.currentSlipInfo.isCheckIsSystem &&
                            this._UiHelper.currentSlipTabSelected == 2
                          "
                          (click)="placeBetActive(true)">
                          {{ 'accept_odds_button_text_5' | translate }}
                        </div>
                      </ng-template>
                    </div>
                    <div
                      class="current-slip-submit-button odd-change"
                      *ngIf="!this._UiHelper.checkboxAcceptOdds && this._DataHelper.currentSlipInfo.oddIsChange"
                      (click)="placeBetActive(true)">
                      <div class="text1">
                        {{ 'accept_odds_button_text_1' | translate }}
                      </div>
                      <div class="text2">
                        {{ 'accept_odds_button_text_2' | translate }}
                      </div>
                    </div>
                  </div>
                  <!-- No Cashout & system & multiway -->
                </ng-container>
              </div>
            </ng-container>
            <ng-template #mobileTemplate>
              <div *ngIf="this._UiHelper.bottomActiveItem === 15" class="slip-amount-bottom sl-round round-bl-5 round-br-5 card">
                <ng-container *ngIf="!('isBetSettings' | getEnv)">
                  <div *ngIf="isMobileView === false" class="accept-odds">
                    <input type="checkbox" id="accept-odds" (change)="this._UiHelper.setAcceptOdds($event)" [(ngModel)]="this._UiHelper.checkboxAcceptOdds" />
                    <label for="accept-odds">{{ 'accept_change_of_odds' | translate }}</label>
                  </div>
                </ng-container>

                <ng-container *ngIf="this._UiHelper.placeBetIsActive">
                  <div class="curent-slip-core-button-row">
                    <button class="submit-ok-button" (click)="placeBet()" mat-stroked-button>
                      {{ 'Confirm' | translate }}
                    </button>
                    <button class="cancel-button" (click)="placeBetActive(false)" mat-stroked-button>
                      {{ 'Modify' | translate }}
                    </button>
                  </div>
                </ng-container>
                <ng-container *ngIf="!this._UiHelper.placeBetIsActive">
                  <div class="submit-bet-row-container">
                    <div class="submit-bet-row-item" [ngClass]="('bookBetQrCode' | getEnv) ? 'isBookBetQrCode' : ''">
                      <ng-container *ngIf="'isJacktimeActive' | getEnv; else isJacktimeNoActive">
                        <div
                          class="btn colored big-size-place"
                          *ngIf="
                            (this._UiHelper.checkboxAcceptOdds || !this._DataHelper.currentSlipInfo.oddIsChange) &&
                            (!this._DataHelper.currentSlipInfo.isCheckIsSystem || this._UiHelper.currentSlipTabSelected != 2 || !this._DataHelper.currentSlipInfo.isMultiWaySystem)
                          "
                          (click)="placeBetActive(true)">
                          {{ 'Submit_Bet' | translate }}
                        </div>
                        <div
                          class="btn colored big-size-place"
                          *ngIf="
                            (this._UiHelper.checkboxAcceptOdds || !this._DataHelper.currentSlipInfo.oddIsChange) &&
                            this._DataHelper.currentSlipInfo.isMultiWaySystem &&
                            this._DataHelper.currentSlipInfo.isCheckIsSystem &&
                            this._UiHelper.currentSlipTabSelected == 2
                          "
                          (click)="placeBetActive(true)">
                          {{ 'Submit_Bet' | translate }}
                        </div>
                      </ng-container>
                      <ng-template #isJacktimeNoActive>
                        <div
                          class="btn colored big-size-place"
                          *ngIf="
                            (this._UiHelper.checkboxAcceptOdds || !this._DataHelper.currentSlipInfo.oddIsChange) &&
                            (!this._DataHelper.currentSlipInfo.isCheckIsSystem || this._UiHelper.currentSlipTabSelected != 2 || !this._DataHelper.currentSlipInfo.isMultiWaySystem)
                          "
                          (click)="placeBetActive(true)">
                          {{ 'Submit_Bet' | translate }}
                        </div>
                        <div
                          class="btn colored no-cashout-button two-line-info"
                          *ngIf="
                            (this._UiHelper.checkboxAcceptOdds || !this._DataHelper.currentSlipInfo.oddIsChange) &&
                            this._DataHelper.currentSlipInfo.isMultiWaySystem &&
                            this._DataHelper.currentSlipInfo.isCheckIsSystem &&
                            this._UiHelper.currentSlipTabSelected == 2
                          "
                          (click)="placeBetActive(true)">
                          {{ 'accept_odds_button_text_5' | translate }}
                        </div>
                      </ng-template>
                    </div>
                    <div
                      class="current-slip-submit-button odd-change"
                      *ngIf="!this._UiHelper.checkboxAcceptOdds && this._DataHelper.currentSlipInfo.oddIsChange"
                      (click)="placeBetActive(true)">
                      <div class="text1">
                        {{ 'accept_odds_button_text_1' | translate }}
                      </div>
                      <div class="text2">
                        {{ 'accept_odds_button_text_2' | translate }}
                      </div>
                    </div>
                  </div>
                  <!-- No Cashout & system & multiway -->
                </ng-container>
              </div>
            </ng-template>
          </ng-container>
          <ng-container *ngIf="this._DataHelper.currentSlipData.length == 0 && isMobileView">
            <div class="bet-slip-mobile-popular-league">
              <div class="bet-slip-empty-container">
                <div class="bet-slip-empty-text">
                  {{ 'current_slip_core_text_4' | translate }}
                </div>
                <image-loader-utils url="empty-betslip" extraClasses="bet-slip-empty-container-svg"></image-loader-utils>
              </div>
              <div
                *ngIf="environment.bookBetQrCode && Array.isArray(this._DataHelper.bookBetsReserveList) && this._DataHelper.bookBetsReserveList.length > 0"
                class="popular-league-button"
                (click)="this.bookBetsReserveRoute()">
                <image-loader-utils url="share" extraClasses="svg popular-leagues-icon"></image-loader-utils>
                <div class="">{{ 'RESERVE_BETS' | translate }}</div>
              </div>
              {{ 'Popular_leagues' | translate }}
              <ng-container *ngFor="let league of topLeaguesData">
                <div class="popular-league-button" (click)="getMatch(league)">
                  <image-loader-utils url="league-icon" extraClasses="svg popular-leagues-icon"></image-loader-utils>

                  <div class="">{{ league.TournamentName }}</div>
                </div>
              </ng-container>
            </div>
          </ng-container>
        </ng-container>
        <!--- My Bets - Cashout - currentSlipHeaderTabSelected = 2 --->
        <ng-container *ngIf="!isMobileView && this._UiHelper.currentSlipHeaderTabSelected == 2">
          <cashout-component (cashoutLengthListener)="cashoutLengthListener($event)"></cashout-component>
        </ng-container>
      </div>
      <!-- Lock area -->
      <ng-container *ngIf="'accountLock' | getEnv">
        <div class="lock-button-main-container text sl-round round-5" *ngIf="this._UserHelper.isSignedIn && this.isMobileView === false">
          <div class="lock-info-text">{{ 'current_slip_core_text_3' | translate }}</div>
          <div class="lock-button-box">
            <div id="accountLockButton24v2" mat-flat-button class="lock-button">
              {{ '24h_Lock' | translate }}
            </div>
            <section class="account-lock-section" *ngIf="progressValue > 0">
              <ng-container *ngIf="holdSeconds != 0">
                <mat-progress-bar class="account-lock-progress-bar" mode="determinate" value="{{ this.progressValue }}"></mat-progress-bar>
                <div class="progress-bar-text">{{ holdSeconds }}</div>
              </ng-container>
            </section>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>
